import React from 'react'

import ButtonDropdown from 'components/ButtonDropdown'
import { Link, useLocation, useParams } from 'react-router-dom'
import styled from 'styled-components'

const RouteLink = styled(Link)<{ active: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 8px;
  font-size: 16px;
  color: ${({ theme }) => theme.text2};

  cursor: pointer;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.text1};
  }

  color: ${(props) => (props.active === true ? '#4AFC38' : '')};
`

const V2V3Switch = () => {
  const location = useLocation()
  const params: any = useParams()

  const currencyIdA = params?.currencyIdA ?? null
  const currencyIdB = params?.currencyIdB ?? null
  const isV2 = location.pathname.toLowerCase().includes('v2')

  const v2Route = `/add/v2${currencyIdA ? `/${currencyIdA}` : ''}${currencyIdB ? `/${currencyIdB}` : ''}`
  const v3Route = `/add${currencyIdA ? `/${currencyIdA}` : ''}${currencyIdB ? `/${currencyIdB}` : ''}`

  return (
    <ButtonDropdown buttonLabel={isV2 ? 'Standard AMM' : 'Concentrated Liquidity'}>
      <RouteLink to={v2Route} active={isV2}>
        AMM Standard Liquidity Position
      </RouteLink>
      <RouteLink to={v3Route} active={!isV2}>
        Concentrated Liquidity Position
      </RouteLink>
    </ButtonDropdown>
  )
}
export default V2V3Switch
